export let addressWork = {
	address_id: '',
	type: '4',
	street: '',
	city: '',
	province: '',
	country: '',
	postalCode: '',
	placeId: '',
	coordinate: { lat: '', lng: '' },
	unit: '',
	fullAddress: '',
};

export let addressHome = {
	address_id: '',
	type: '5',
	street: '',
	city: '',
	province: '',
	country: '',
	postalCode: '',
	placeId: '',
	coordinate: { lat: '', lng: '' },
	unit: '',
	fullAddress: '',
};

export let addressOther = {
	address_id: '',
	type: '6',
	street: '',
	city: '',
	province: '',
	country: '',
	postalCode: '',
	placeId: '',
	coordinate: { lat: '', lng: '' },
	unit: '',
	fullAddress: '',
};
